<script>
  export default {
    name: 'hive-icon',

    props: {
      icon: {
        type: String,
        required: true
      },
      fill: {
        type: String
      }
    }
  }
</script>

<template>
  <div class="hive-icon">
    <img :src="icon" alt="" v-if="icon"/>
    <svg height="40" width="35" >
      <path :fill="fill || '#ffffff'" d="M17.32050807568877 0L34.64101615137754 10L34.64101615137754 30L17.32050807568877 40L0 30L0 10Z"></path>
    </svg>
  </div>
</template>

<style src="./HiveIcon.scss" lang="scss"></style>
